import type { JsonHttpRequestOptions } from '../interfaces/JsonHttpRequestOptions'
import type { NetworkInterface } from '../interfaces/NetworkInterface'
import type { PaginatedResponse } from '../interfaces/PaginatedResponse'
import type { ProxmoxMachine } from '../interfaces/ProxmoxMachine'
import Http from '../utils/http'

interface GetProxmoxMachinesParams {
    sort?: string[]
    filter?: Record<string, string | number | boolean>
    include?: string[]
    per_page?: number
    page?: number
}

const getProxmoxMachines = (
    params: GetProxmoxMachinesParams = {},
    options?: JsonHttpRequestOptions
): Promise<PaginatedResponse<ProxmoxMachine>> => {
    const queryParams = new URLSearchParams()

    if (params.sort && params.sort.length > 0) {
        queryParams.append('sort', params.sort.join(','))
    }

    if (params.filter) {
        Object.entries(params.filter).forEach(([key, value]) => {
            queryParams.append(`filter[${key}]`, String(value))
        })
    }

    if (params.include && params.include.length > 0) {
        queryParams.append('include', params.include.join(','))
    }

    if (params.per_page !== undefined) {
        queryParams.append('per_page', String(params.per_page))
    }

    if (params.page !== undefined) {
        queryParams.append('page', String(params.page))
    }

    const url = `/api/proxmox-machines${queryParams.toString() ? `?${queryParams.toString()}` : ''}`

    return Http.getJson<PaginatedResponse<ProxmoxMachine>>(url, options)
}

const suspendMachine = (
    machineId: number,
    options?: JsonHttpRequestOptions
): Promise<void> => {
    return Http.postJson(
        `/api/proxmox-machines/${machineId}/suspend`,
        {},
        options
    )
}

const rebootMachine = (
    machineId: number,
    options?: JsonHttpRequestOptions
): Promise<void> => {
    return Http.postJson(
        `/api/proxmox-machines/${machineId}/reboot`,
        {},
        options
    )
}

const shutdownMachine = (
    machineId: number,
    options?: JsonHttpRequestOptions
): Promise<void> => {
    return Http.postJson(
        `/api/proxmox-machines/${machineId}/shutdown`,
        {},
        options
    )
}

const getNetworkInfo = (
    machineId: number,
    options?: JsonHttpRequestOptions
): Promise<{ data: NetworkInterface[] }> => {
    return Http.getJson<{ data: NetworkInterface[] }>(
        `/api/proxmox-machines/${machineId}/network-info`,
        options
    )
}

export default {
    getProxmoxMachines,
    suspendMachine,
    rebootMachine,
    shutdownMachine,
    getNetworkInfo,
}
